<template>
  <div id="app">
    <NavigationBar/>
    <router-view/>
  </div>
</template>

<script>
// @ is an alias to /src
import NavigationBar from '@/components/NavigationBar.vue'

export default {
  name: 'App',
  components: {
    NavigationBar
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Gemunu+Libre:wght@700&display=swap');
html {
  font-size: 20px;
}
body, html { overflow-x:hidden; }
nav, h1 {
  font-family: 'Gemunu Libre', sans-serif;
  font-weight: 500;
}
.schedule, .results, .register { 
  font-family: 'Gemunu Libre', sans-serif;
  font-weight: 100;
}
nav + .container {
      padding: 5% 0;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

td a {
    color: #337ab7;
    text-decoration: none;
}
</style>
